/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useState } from 'react'
import api from '@/api'
import { Mask, Toast } from 'antd-mobile'

import './index.scss'
import closeGray from '@/images/close-gray.png'

const CouponExchange = (props) => {
  const { isShow, onClose, onSuccess } = props

  const [coupon_code, setCoupon_code] = useState('')

  const couponInput = (e) => {
    setCoupon_code(e?.target?.value)
  }

  const closeMask = () => {
    onClose && onClose()
  }

  const exchnageConfirm = () => {
    const _coupon_code = coupon_code.trim()
    if (!_coupon_code) {
      Toast.show({
        content: '券码不能为空',
      })
      return
    }
    const payLoad = { coupon_code: _coupon_code }
    api.post('/coupon/receive', payLoad, { showLoading: true }).then(res => {
      console.log(11111, res)
      if (res?.error) return
      Toast.show({
        content: res?.message || '领取成功！',
        duration: 3000,
        maskClickable: false,
      })
      setTimeout(() => {
        onSuccess && onSuccess()
        onClose && onClose()
      }, 3000)
    })
  }

  return <Mask className="exchange-coupon-container-mask"
      destroyOnClose
      onMaskClick={closeMask}
      visible={isShow}>
    <div className="exchange-coupon-container">
      <div className="exchange-coupon-title">兑换优惠券</div>
      <img className="exchange-coupon-close"
          onClick={closeMask}
          src={closeGray} />
      <input className="exchange-coupon-input"
          onChange={couponInput}
          placeholder="请输入兑换的券码"
          type="text" />
      <div className="exchange-coupon-btn"
          onClick={exchnageConfirm}>确定</div>
    </div>

  </Mask>
}

export default CouponExchange